<template>
    <v-card class="overflow-hidden">
        <v-app-bar id="menu" app dense flat tile elevation="0" color="#fff" class="menu-border" height="48px">
            <AppMenuNav v-if="$vuetify.breakpoint.width >= 975" :items="navMenuItemsWL"></AppMenuNav>

            <v-app-bar-nav-icon
                v-if="$vuetify.breakpoint.width < 975"
                class="ml-n3 ml-md-0 hi"
                @click="mobileMenuDrawer = true"
                style="color: #6aa84f"
            ></v-app-bar-nav-icon>

            <v-spacer></v-spacer>

            <AppSearch></AppSearch>

            <AppMenuDarkSwitcher></AppMenuDarkSwitcher>

            <AppMenuAccountWL></AppMenuAccountWL>

            <AppMenuNotification></AppMenuNotification>

            <AppMenuHelp :items="navMenuSupportItems"></AppMenuHelp>
        </v-app-bar>
        <!--        <AppMenuMobile :items="navMenuItemsWL"></AppMenuMobile>-->
    </v-card>
</template>
<style scoped>
    .theme--dark {
        background-color: #1e1f22 !important;
        color: white !important;
    }
</style>
<script>
    import utils from '../../helpers/utils';
    import AppMenuNotification from './AppMenuNotification';
    import AppMenuHelp from './AppMenuHelp';
    import AppMenuDarkSwitcher from './AppMenuDarkSwitcher';
    import AppMenuMobile from './AppMenuMobile';
    import AppMenuBreadcrumbs from './AppMenuBreadcrumbs';
    import AppSearch from './../../pages/core/search/AppSearch';
    import AppMenuNav from './AppMenuNav';
    import AppMenuAccountWL from './AppMenuAccountWL';

    export default {
        name: 'app-menu-wl-player',
        components: {
            AppMenuAccountWL,
            AppMenuNav,
            AppMenuBreadcrumbs,
            AppMenuMobile,
            AppMenuNotification,
            AppMenuHelp,
            AppMenuDarkSwitcher,
            AppSearch,
        },
        watch: {
            '$vuetify.breakpoint.width': {
                handler() {
                    if (this.$vuetify.breakpoint.width > 974) {
                        this.mobileMenuDrawer = false;
                    }
                },
            },
        },
        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },
        mounted() {
            this.requiredDictionaries = ['TimeZone', 'Site'];
        },

        mixins: [utils],
        methods: {},
        computed: {
            mobileMenuDrawer: {
                get() {
                    return this.$store.getters['MenuModule/getMobileMenuDrawer'];
                },
                set(value) {
                    this.$store.commit('MenuModule/setMobileMenuDrawer', value);
                },
            },
            requiredDictionaries: {
                get() {
                    return this.$store.getters['PageModule/getRequiredDictionaries'];
                },
                set(value) {
                    this.$store.commit('PageModule/setRequiredDictionaries', value);
                },
            },
            navMenuSupportItems: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuWLSupportItems'];
                },
            },
            navMenuItemsWL: {
                get() {
                    return this.$store.getters['MenuModule/getNavMenuItemsWL'];
                },
            },
        },
    };
</script>
